import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import { CalendarAccountData } from '../store/schema/CalendarAccountData';

export const addToAccountsMap = mutatorAction(
    'addToAccounts',
    (accountId, userId, calendarEndpointType, loadState) => {
        const store = getStore();
        const calendarAccountData: CalendarAccountData = {
            calendarEndpointType: calendarEndpointType,
            userId: userId,
            loadState: loadState,
        };
        if (!store.calendarAccountLoadMap.has(accountId)) {
            store.calendarAccountLoadMap.set(accountId, calendarAccountData);
        }
    }
);

export const updateAccountLoadState = mutatorAction(
    'updateAccountLoadState',
    (accountId, loadState) => {
        const store = getStore();
        const accountData = store.calendarAccountLoadMap.get(accountId);
        accountData.loadState = loadState;
        store.calendarAccountLoadMap.set(accountId, accountData);
    }
);
